import React from "react";
import { ChatCircleDots, Robot, Clock, Calendar } from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

export default function AILeadAutoreply() {
  return (
    <ComingSoonShell
      testid="coming-soon-ailead"
      title={<>Risposta <span className="font-editorial italic">automatica</span></>}
      subtitle="alle richieste, con il tuo tono."
      intro="Un cliente lascia un messaggio sulla tua pagina annuncio. Pronto risponde subito, in italiano, con il tuo nome e propone 3 slot per il sopralluogo. Tu approvi prima dell'invio."
      preview={(
        <div className="flex flex-col gap-2.5 max-w-md mx-auto">
          <div className="self-start max-w-[78%] bg-[#F5F4F0] rounded-2xl rounded-bl-sm px-3.5 py-2 text-[13px] text-[#1C1C1A]">
            <div className="text-[10px] uppercase tracking-[0.14em] text-[#9A968B] font-bold mb-0.5">Cliente</div>
            "Salve, sono interessato al trilocale di via Brera. Quando si può vedere?"
          </div>
          <div className="self-end max-w-[80%] bg-[#7C8B6E] text-white rounded-2xl rounded-br-sm px-3.5 py-2 text-[13px]">
            <div className="text-[10px] uppercase tracking-[0.14em] text-white/70 font-bold mb-0.5">Pronto · bozza per te</div>
            Buongiorno! Sono Marco di Pronto Immobiliare. Per il trilocale di
            via Brera ho disponibilità giovedì alle 17, venerdì alle 11 o
            sabato mattina. Quale le va meglio?
          </div>
          <div className="self-end inline-flex items-center gap-1.5 text-[10.5px] text-[#9A968B] font-semibold">
            <Clock size={10} weight="fill" /> Risposta in 12 secondi · in attesa di approvazione
          </div>
        </div>
      )}
      whyNotYet="Vogliamo che ogni risposta automatica suoni come te — non come un bot. Per questo, prima del rilascio, useremo le risposte che tu già scrivi a mano per imparare il tuo tono. Così quando rispondiamo al posto tuo, il cliente non si accorge di nulla. Ci serve qualche settimana di dati reali per tararlo bene."
      whatItWillDo={[
        { icon: Robot, label: "Bozza pronta in pochi secondi", body: "Leggiamo il messaggio del cliente e prepariamo una risposta col tuo tono. Tu approvi (1 click) o riscrivi al volo." },
        { icon: Calendar, label: "Slot di sopralluogo proposti", body: "Pronto guarda la tua agenda e propone 3 slot liberi nel messaggio — il cliente clicca e prenota direttamente." },
        { icon: ChatCircleDots, label: "Risposta in italiano editoriale", body: "Niente \"egregio sig.\" da call center: il messaggio sembra scritto da te, non da una macchina. Il cliente non se ne accorge." },
      ]}
      interestSlug="ai-lead"
      interestTitle="Risposta automatica alle richieste"
    />
  );
}
